// 定义一个全局的监听器，检测元素可见性变化，根据配置信息，添加对应样式
const observer = new IntersectionObserver(
  async (changes) => {
    changes.sort((a, b) => {
      return a.target.getAttribute('anim') - b.target.getAttribute('anim');
    });

    for await (const change of changes) {
      let cslist = [...change.target.classList];
      if (change.isIntersecting) {
        cslist = cslist.filter((item) => item !== 'animation');
        change.target.className = [...cslist, 'animation'].join(' ');
      }

      // if (!change.isIntersecting && change.boundingClientRect.y > 50) {
      //     if (cslist.includes('once')) {
      //         observer.unobserve(change.target);
      //     }

      //     change.target.className = [...cslist].filter(item => item !== 'animation').join(' ')
      // }
      // 定价页特殊处理下
      if (cslist.includes('contract-end')) {
        await waitTime(500);
      }
    }
  },
  { thresholds: [0, 1] }
);

const waitTime = (number = 0) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      return resolve();
    }, number);
  });
};

// selector = []
export const observe = (selector) => {
  [...document.querySelectorAll(selector.join(', '))].forEach((target) => {
    observer.observe(target);
  });
};
